(function() {
    require('./pages/common');
})();


// WEBPACK FOOTER //
// ./src/js/app.js